import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";

function SkeletonComponent() {
  const objs = [
    [
      {
        name: "Health Insurance (if not deducted from paycheck)",
      },
    ],
    [
      {
        name: "Dental and orthodontia",
      },
    ],
    [
      {
        name: "Medical and prescriptions",
      },
    ],
    [
      {
        name: "Counseling and therapy",
      },
    ],
    [
      {
        name: "Glasses and contacts",
      },
    ],
  ];

  return (
    <>
      {objs.map((obj) => (
        <tr>
          <td>{obj[0].name}</td>
          <td>
            <Skeleton height={18} width={90} variant="text" />
          </td>
          <td>
            <Skeleton height={18} width={90} variant="text" />
          </td>
        </tr>
      ))}
    </>
  );
}

export default SkeletonComponent;
